<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <!-- <div class="personal-details">
                <h4 class="personal-details-title">To Be Approve</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Application Form</th>
                      <th scope="col">Application Name</th>
                      <th scope="col">Applicant EmailID</th>
                      <th scope="col">Applicant Mobile</th>
                      <th scope="col">Applicant status</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let x of data ;let i = index">
                      <td scope="col">{{x.prospectRegistrationId}}</td>
                      <td scope="col">{{x.applicationFormFor}}</td>
                      <td scope="col">{{x.applicationName}}</td>
                      <td scope="col">{{x.applicantEmailId}}</td>
                      <td scope="col">{{x.applicantMobileNo}}</td>
                      <td scope="col">{{x.latestApplicationStatus}}</td>
                      <td>
                        <svg xmlns="http://www.w3.org/2000/svg" (click)="getProspectByID(x.prospectRegistrationId)" data-toggle="modal" data-target="#exampleModalCenter"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                        </svg> 
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div> -->


            <div class="personal-details">

              <div class="header-block">
                  <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                  </div>
                   <div class="add-block">
                    <div class="search">
                      <form autocomplete="off" >
                        <input type="text" placeholder="search" (keyup.enter)="getAllProspectRegistrationWildSearchWithPagination(0,10)" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchFilter">
                      </form>
                      <i class="bi bi-search" (click)="getAllProspectRegistrationWildSearchWithPagination(0,10)"></i>
                    </div>

                    <div class="filter-icon">
                      <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                    </div>
                  </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 15%;">Application Form</th>
                        <th style="width: 15%;">Application Name</th>
                        <th style="width: 20%;">Applicant EmailID</th>
                        <th style="width: 15%;">Applicant Mobile</th>
                        <th style="width: 15%;">Applicant Status</th>
                        <th style="width: 10%;">Created Date</th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let list of data | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">
      
                      <p style="width: 15%;">{{list.applicationFormFor}}</p>
                      <p style="width: 15%;">{{list.applicationName}}</p>
                      <p style="width: 20%;">{{list.applicantEmailId}}</p>
                      <p style="width: 15%;">{{list.applicantMobileNo}}</p>
                      <p style="width: 15%;">{{list.latestApplicationStatus}}</p>
                      <p style="width: 10%;">{{list.createdDate | date}}</p>
                      <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i *ngIf="actionControls.isView" (click)="getProspectByID(list.prospectRegistrationId)" data-toggle="modal" data-target="#exampleModalCenter" class="bi bi-eye-fill"></i>
                      </p>
                  </div>
              </div>
      
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && data.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
      
        
          </div>
        </div>
    </div>
</div>

<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="prospect-block" *ngFor="let data of prospectdata">
        <div class="prospect-content">
          <div class="application-details">
            <p class="application-title">Application Details:</p>
            <div class="row application-form-details">
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Application For</label>
                <p>{{data.applicationFormFor}}</p>
              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Number of Cable Connection</label>
                <p>{{data.noOfCableConnection}}</p>
              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Number of Internet Connection</label>
                <p>{{data.noOfInternetConnection}}</p>
              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Terms of Payment</label>
                <p>{{data.termsOfPayment}}</p>
              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Booked By</label>
                <p>{{data.bookedBy}}</p>
              </div>
              <div class="col-md-4 col-lg-4 application-form">
                <label for="">Agent Name</label>
                <p *ngIf="data.agentName != ''">{{data.agentName}}</p>
                <p *ngIf="data.agentName == ''">--</p>
              </div>
            </div>
          </div>

          <div class="applicant-details">
            <p class="applicant-title">Personal Details:</p>
            <div class="row applicant-form-details">
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Name</label>
                <p>{{data.applicationName}}</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Father/Husband Name</label>
                <p>{{data.fatherHusbandName}}</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Email</label>
                <p *ngIf="data.applicantEmailId != ''">{{data.applicantEmailId}}</p>
                <p *ngIf="data.applicantEmailId == ''">--</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Mobile No</label>
                <p>{{data.applicantMobileNo}}</p>
              </div>
              <div class="col-md-4 col-lg-4 applicant-form">
                <label for="">Address</label>
                <p>{{data.installationAddress}}</p>
              </div>
            </div>
          </div>


          <div class="identity-proof-details">
            <p class="identity-proof-title">Identity Proofs:</p>
            <div class="row identity-proof-form-details">
              <div class="col-md-12 col-lg-12 identity-proof-form">
                <label for="">Proof Type</label>
                <p>{{data.identityProofType}}</p>
                <div class="proof-images">
                  <div class="image">
                    <img src="{{data.identityProofAttachmentURL}}" alt="">
                  </div>
                  <div class="image">
                    <img src="{{data.photoAttachmentURL}}" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div class="feasibility-details">
            <p class="feasibility-title">Feasibility Details:</p>
            <div class="row feasibility-form-details">
              <div class="col-md-12 col-lg-12 feasibility-form">
                <label for="">Feasibility Report</label>
                <p>{{data.description}}</p>
              </div>

              <div class="feasibility-images" >
                <div class="image col-md-3 col-lg-3" *ngFor="let image of data.feasibilityImageList">
                  <img src="{{image}}" alt="">
                </div>
              </div>
            </div>
          </div>

      


        </div>
        <div class="modal-footer">
          <button type="button" *ngIf="data.latestApplicationStatus != 'APPROVED' && data.latestApplicationStatus != 'REJECTED'" class="btn btn-danger left" (click)="rejection()" >Reject</button>
          <button type="button" id="closeModalButton" (click)="cancelModel()" class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
          <button type="button" *ngIf="data.latestApplicationStatus != 'APPROVED' && data.latestApplicationStatus != 'REJECTED'" (click)="approval()" class="btn btn-primary">Approve</button>
        </div>
      </div>
    </div>
  </div>
</div>